// extracted by mini-css-extract-plugin
export default {"root":"HeaderHistory_root__9GnFD","wrapperSelect":"HeaderHistory_wrapperSelect__E+liK"};